import { combineReducers } from "redux";
import { getFailureActionType, getSuccessActionType } from "../utils";
import { UPDATE_ADMIN_WORKING_HOURS_REQUEST, FETCH_ADMIN_WORKING_HOURS_REQUEST } from "./constants";
import { Action } from "./types";

function items(state = {}, action: Action) {
  switch (action.type) {
    case getSuccessActionType(FETCH_ADMIN_WORKING_HOURS_REQUEST): {
      return action.payload;
    }

    default:
      return state;
  }
}

function isFetching(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case FETCH_ADMIN_WORKING_HOURS_REQUEST:
    case UPDATE_ADMIN_WORKING_HOURS_REQUEST:
      return true;

    case getSuccessActionType(FETCH_ADMIN_WORKING_HOURS_REQUEST):
    case getFailureActionType(FETCH_ADMIN_WORKING_HOURS_REQUEST):
    case getSuccessActionType(UPDATE_ADMIN_WORKING_HOURS_REQUEST):
    case getFailureActionType(UPDATE_ADMIN_WORKING_HOURS_REQUEST):
      return false;
    default:
      return state;
  }
}

export const settings = combineReducers({ items, isFetching });
